"use strict";

var _regeneratorRuntime = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var req = require('tiny_request');

function postRequest(url, query) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              req.post({
                url: url,
                form: query,
                json: true,
                timeout: timeout
              }, function (body, response, err) {
                resolve({
                  body: body,
                  response: response,
                  err: err
                });
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.postRequest = postRequest;